/* eslint-disable no-unused-vars */
import Divider from "components/Divider";
import H4 from "components/H4";
import H5 from "components/H5";
import React, { useState } from "react";
import styled from "styled-components";
import Svg from "_assets/svg";
import { useDispatch } from "react-redux";
import { useHistory, Redirect } from "react-router-dom";
import { logout } from "_redux/actions/authAction";
import DropdownWrapper from "./DropdownWrapper";

const Button = styled.button`
  padding-left: 10px;
  padding-right: 15.83px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #bbc1c8;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus {
    outline: 0px;
  }
`;

const Img = styled.img`
  ${(props) => `
    width: ${props.size ? `${props.size}px` : "32px"};
    height: ${props.size ? `${props.size}px` : "32px"};
    border-radius: ${props.size ? `${props.size / 2}px` : "18px"};
  `}
`;

const Arrow = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 5px;
`;

const H3 = styled.span`
  /* Project Barongsai */

  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  color: #3a3c40;
`;

const H6 = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #838890;
  /* identical to box height, or 150% */
`;

const DropdownButton = styled.button`
  padding-block: 8px;
  padding-inline: 0px;
  background: transparent;
  border-radius: 8px;
  border: 0px;
  cursor: pointer;
  &:focus {
    outline: 0px;
  }
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

const DropdownImg = styled.img`
  width: 20px;
  height: 20px;
`;

const ButtonUserWrapper = (props) => {
  const { isLogout, title, svg, onPress } = props;
  return (
    <DropdownButton onClick={onPress} className="d-flex flex-row align-items-center w-100">
      <DropdownImg src={svg.default} />
      <H4 style={{ color: isLogout ? "#D63358" : "#26292D", fontWeight: "bold", marginLeft: 10 }}>
        {title}
      </H4>
    </DropdownButton>
  );
};
const ButtonUser = ({ user }) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const onLogOut = () => {
    dispatch(logout());
    history.push("/auth/login");
    localStorage.removeItem("DATA_FORM")
  };
  const [active, setActive] = useState(false);
  const handleDropdown = () => {
    setActive(!active);
  };

  return (
    <div className="position-relative">
      <Button
        className="d-flex flex-row justify-content-between align-items-center w-100"
        style={{ marginTop: 15 }}
        onClick={() => handleDropdown()}
      >
        <div />
        <div>
          <Img
            style={{ marginRight: 5 }}
            src={require("_assets/images/example_person.png").default}
          />
          <H5 className="fw-bold">{user?.fullName}</H5>
        </div>
        <Arrow src={Svg.arrow_drop_down.default} />
      </Button>
      <DropdownWrapper active={active}>
        <div
          className="justify-content-center align-items-center d-flex flex-column"
          style={{ paddingBlock: 20, paddingInline: 25 }}
        >
          <Img size={70} src={require("_assets/images/example_person.png").default} />
          <H3 style={{ marginTop: 10, marginBottom: 2 }}>{user?.fullName}</H3>
          <H5 color="#838890">{user?.email}</H5>
        </div>
        <Divider style={{ marginBlock: 15, marginInline: 0 }} />
        <div style={{ paddingInline: 15, paddingBottom: 15 }}>
          <H6 style={{ marginBottom: 4 }}>PERSONAL</H6>
          <ButtonUserWrapper
            onPress={() => history.push("/profile/edit-profile")}
            svg={Svg.user}
            title="Edit Profile"
          />
          <ButtonUserWrapper
            onPress={() => history.push("/profile/change-password")}
            svg={Svg.locked}
            title="Change Password"
          />
          <Divider style={{ marginBlock: 15, marginInline: 0 }} />
          <H6 style={{ marginBottom: 4 }}>ORGANIZATION</H6>
          <ButtonUserWrapper
            onPress={() => history.push("/profile/edit-organization")}
            svg={Svg.u_bag}
            title="Edit Organization"
          />
          <Divider style={{ marginBlock: 15, marginInline: 0 }} />
          <ButtonUserWrapper svg={Svg.log_out} title="Logout" isLogout onPress={() => onLogOut()} />
        </div>
      </DropdownWrapper>
    </div>
  );
};

export default ButtonUser;
